import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IUser } from '../models/index';
import { selectUser } from '../store/auth/auth.selectors';

@Injectable({
  providedIn: 'root', // Lo hacemos 'root' para que sea un singleton en toda la app
})
export class PermissionsService {
  private _user!: IUser | null;

  constructor(private _store: Store) {
    this._store.select(selectUser).subscribe((user: IUser | null) => {
      this._user = user;
    });
  }

  hasPermissions(permissions: string[][] | null | undefined): boolean {
    if (!permissions || permissions?.length === 0) {
      return true;
    }
    const hasAllPermissions = permissions.every((permissionPath) => {
      const permissionValue = this.getNestedValue({ ...(this._user || {}) }, permissionPath);
      return permissionValue === true;
    });
    return hasAllPermissions;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getNestedValue(obj: any, path: string[]): any {
    return path.reduce((currentObject, key) => {
      return currentObject?.[key];
    }, obj);
  }
}
